import styled from 'styled-components';

import { Modal as ModalComponent } from 'react-bootstrap';

export const Container = styled.div`
  min-width: calc(100% - 88px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  .container-fluid {
    max-width: 1460px;
  }

  .bg-white {
    border-radius: 8px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
    transition: opacity 0.2s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-outline-secondary {
    border-radius: 4px;
  }

  .height {
    height: 40px;
    border-radius: 4px;

    input:disabled {
      opacity: 0.5;
    }
  }

  .label {
    font-size: 14px;
    font-weight: 500;
    color: #444141;
    margin-bottom: 6px;
  }

  .hint-text {
    font-size: 12px;
    color: #a8a8a8;
  }

  .badge-status {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.02em;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
  }

  .badge-active {
    background: #e3f8ec;
    color: #00b15c;
  }

  .badge-inactive {
    background: #f1f2f5;
    color: #8c8c8c;
  }

  .badge-version {
    background: #f1f2f5;
    color: #5d5d5d;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  .title {
    color: #000;
    font-size: 26px;
    font-weight: 500;
  }
`;

export const TreeCard = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 210px);
  min-height: 460px;

  .tree-header {
    border-bottom: 1px solid #f1f1f1;
  }

  .tree-body {
    flex: 1;
    overflow-y: auto;

    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 4px;
    }
  }

  .tree-group-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #b1b1b1;
    padding: 0 8px;
  }

  .tree-item {
    width: 100%;
    text-align: left;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 6px;
    padding: 8px 10px;
    margin-top: 2px;
    font-size: 14px;
    color: #5d5d5d;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.15s;

    svg {
      flex-shrink: 0;
      color: #a8a8a8;
    }

    &:hover {
      background: #f7f8fa;
    }

    &.active {
      background: #eaf1fb;
      border-color: #cfe0f5;
      color: #002f6c;
      font-weight: 500;

      svg {
        color: #002f6c;
      }
    }
  }

  .department-toggle {
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 14px;
    font-weight: 500;
    color: #383838;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background: #f7f8fa;
    }

    .arrow {
      display: flex;
      color: #a8a8a8;
    }

    .folder-icon {
      color: #ff6900;
    }
  }

  .tree-sublist {
    margin: 2px 0 4px 20px;
    padding-left: 12px;
    border-left: 2px solid #f1f1f1;
  }

  .btn-new-agent {
    background: #ff690000;
    transition-duration: 0.3s;
    border-radius: 4px;

    :hover {
      background: #ff690022;
    }
  }
`;

export const EditorCard = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 210px);
  min-height: 460px;

  .breadcrumb {
    font-size: 12px;
    color: #a8a8a8;
  }

  .editor-body {
    flex: 1;
    overflow-y: auto;

    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 4px;
    }
  }

  .empty-state {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #b1b1b1;
    font-size: 14px;
    padding: 24px;
  }
`;

export const PromptEditor = styled.div`
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #333;

  .editor-file-name {
    background: #2d2d2d;
    color: #b8b8b8;
    font-size: 12px;
    font-family: 'Roboto Mono', monospace;
    padding: 8px 14px;
    border-bottom: 1px solid #3a3a3a;
  }

  .prompt-textarea {
    background: #1e1e1e;
    border: none;
    border-radius: 0;
    margin-top: 0 !important;

    textarea {
      color: #d4d4d4;
      font-family: 'Roboto Mono', monospace;
      font-size: 13px;
      line-height: 1.6;

      ::placeholder {
        color: #6a6a6a;
      }
    }
  }
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .height {
    height: 40px;
    border-radius: 4px;

    input:disabled {
      opacity: 0.5;
    }
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
